import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { SUBMIT_URL } from "../service/data";

const initialState = {
  submitReviewalResponse: {},
  submitDataLoading: false,
  submitDataError: null,
  submitDataSuccess: false,
  submitDataStatus: null,
};

export const submitData = createAsyncThunk(
  "submitData",
  async (
    { id, targetScenario, submitData, accessToken },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          // Authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      };
      const { data } = await axios.post(
        `${SUBMIT_URL}/${id}/review/${targetScenario}`,
        submitData,
        config
      );
      return data;
    } catch (error) {
      if (error.message && error.message === "Network Error") {
        return rejectWithValue(error.message);
      }
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const submitDataSlice = createSlice({
  name: "submitReviewalResponse",
  initialState,
  reducers: {
    setSubmitData: (state, action) => {
      state.submitReviewalResponse = action.payload;
    },
  },
  extraReducers: {
    [submitData.pending]: (state) => {
      state.submitDataLoading = true;
      state.submitDataerror = null;
    },
    [submitData.fulfilled]: (state, { payload }) => {
      state.submitDataLoading = false;
      state.submitDataSuccess = true;
      state.submitReviewalResponse = payload;
    },
    [submitData.rejected]: (state, { payload }) => {
      state.submitDataLoading = false;
      state.submitDataError = payload;
    },
  },
});

export const { setSubmitData } = submitDataSlice.actions;

export default submitDataSlice.reducer;
